import Loader from '../assets/img/loader.svg';

export const LoaderCmp = () => {
    return (
        <section className="loader">
            <img src={Loader} alt="Loader"/>
            Loading...
        </section>
    )
}